import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import api from '../../api/client';
import { Button } from '../common';

/**
 * TopicModal - Add or edit topic
 */
const TopicModal = ({ topic, meetingId, onClose, onSave }) => {
  const [editedTopic, setEditedTopic] = useState({
    title: topic?.title || '',
    details: topic?.description || topic?.details || '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Update state when topic prop changes
  useEffect(() => {
    if (topic) {
      console.log('TopicModal - Loading topic:', topic);
      setEditedTopic({
        title: topic.title || '',
        details: topic.description || topic.details || '',
      });
    } else {
      setEditedTopic({
        title: '',
        details: '',
      });
    }
  }, [topic]);

  const handleSave = async () => {
    if (!editedTopic.title.trim()) {
      setError('Topic title is required');
      return;
    }
    setError('');
    setSaving(true);
    try {
      if (topic?.id) {
        await api.patch(`/topics/${topic.id}`, editedTopic);
      } else {
        await api.post('/topics', {
          ...editedTopic,
          meetingId,
        });
      }
      onSave();
    } catch (error) {
      setError(error.message || 'Failed to save topic');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">{topic ? 'Edit Topic' : 'Add Topic'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-error">{error}</div>}
          <div className="form-group">
            <label className="form-label">Title *</label>
            <input
              type="text"
              className="form-input"
              value={editedTopic.title}
              onChange={(e) => setEditedTopic({ ...editedTopic, title: e.target.value })}
              placeholder="Enter topic title"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Details (optional)</label>
            <textarea
              className="form-input"
              value={editedTopic.details}
              onChange={(e) => setEditedTopic({ ...editedTopic, details: e.target.value })}
              placeholder="Add any additional details"
              rows={3}
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  );
};

TopicModal.propTypes = {
  topic: PropTypes.object,
  meetingId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default TopicModal;
